import { SpaClass } from '@features/spa/pages/SpaClasses/SpaClasses.types';
import { useQuery } from '@tanstack/react-query';
import request from '@utils/request';
import { some } from '@utils/some';
import { SPA_AVAILABILITY_TIMEOUT } from './consts';

export const spaClassKeys = {
  spaClassKey: ['spaClass'] as const,
  spaClass: (
    propertyId: number,
    language: string,
    { arrivalDate, perPage }: { arrivalDate: string; perPage: number }
  ) => [...spaClassKeys.spaClassKey, propertyId, language, { arrivalDate, perPage }] as const,
};

export const useGetSpaClasses = (
  propertyId: number,
  language: string,
  arrivalDate: string,
  perPage = 0
) => {
  return useQuery({
    queryFn: () => getSpaClasses(propertyId, language, { perPage, arrivalDate }),
    queryKey: spaClassKeys.spaClass(propertyId, language, { arrivalDate, perPage }),
  });
};

export const getSpaClasses = async (
  propertyId: number,
  language: string,
  { arrivalDate, perPage }: { arrivalDate: string; perPage: number }
) => {
  const { data } = await request.get(`${propertyId}/spa-classes/${language}`, {
    params: {
      arrivalDate,
      perPage,
      fallback: 1,
    },
    timeout: SPA_AVAILABILITY_TIMEOUT,
  });
  return (data.data as Array<SpaClass>).map((spaClass) => ({
    ...spaClass,
    availability: some(spaClass.availability) ? spaClass.availability : [],
  }));
};
